export default __webpack_public_path__ + "static/media/doneLaundry.fe133208.jpg";